import React, {Component} from 'react';
import ReactGA from 'react-ga';
import {HashRouter as Router, Route} from 'react-router-dom';
import {I18nextProvider} from 'react-i18next';
import BackButton from './atoms/BackButton';

import Routes from './routes';
import i18n from './locales/i18n';
import './App.css';

ReactGA.initialize('UA-117842856-2');

class App extends Component {
    render() {
        return (
            <main className="App">
                <I18nextProvider i18n={i18n}>
                    <Router>
                        <React.Fragment>
                            <Route path={/^\/.+/} component={BackButton} />
                            <Routes />
                        </React.Fragment>
                    </Router>
                </I18nextProvider>
            </main>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js